import axios from 'axios';
import config from '../../config';

const http = axios.create({
  headers: {
    Accept: 'application/json'
  }
})

export default {
    signin: (email, password) => {
      return new Promise((resolve, reject) => {
        const model = {
          email: email,
          password: password
        }
        http.post(config.apiEndpoints.usersUri.concat('signin'), model).then(
          response => {
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    resetPassword: (email, password, code) => {
      return new Promise((resolve, reject) => {
        const model = {
          email: email,
          password: password,
          code: code
        }
        http.post(config.apiEndpoints.accountUri.concat('reset'), model).then(
          response => {
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    sendToken: (email) => {
      return new Promise((resolve, reject) => {
        const model = {
          email: email
        }
        http.post(config.apiEndpoints.accountUri.concat('token'), model).then(
          response => {
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      })
    }
}
